import {createFileRoute, Outlet} from '@tanstack/react-router';
import {DepositApplicationSectionProvider} from 'features/deposit/onboarding/context/DepositApplicationSectionProvider';
import {DepositApplicationKycSectionProvider} from 'features/deposit/onboarding/context/DepositApplicationKycSectionProvider';

const DepositApplicationLayout = () => {
  return (
    <DepositApplicationKycSectionProvider>
      <DepositApplicationSectionProvider>
        <Outlet />
      </DepositApplicationSectionProvider>
    </DepositApplicationKycSectionProvider>
  );
};

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/$applicationId',
)({
  component: DepositApplicationLayout,
});
